<template>
  <div>
    <component :is="CompanyComponent" />
  </div>
</template>

<script lang="ts">
import { defineNuxtComponent } from '#app'
import { useCompanyStore } from '~/store/company'

export default defineNuxtComponent({
  name: 'Company',
  setup () {
    const companyStore = useCompanyStore()
    function templateImport (template) {
      switch (template) {
        case 'base':
          return import('~/components/templates/base/index.vue')
        case 'base_light':
          return import('~/components/templates/base_light/index.vue')
        case 'light_ya':
          return import('~/components/templates/light_ya/index.vue')
        case 'ad_light':
          return import('~/components/templates/ad_light/index.vue')
        case 'rd_light':
          return import('~/components/templates/rd_light/index.vue')
        case 'hospitality':
          return import('~/components/templates/hospitality/index.vue')
        case 'tech_ofs_v1':
          return import('~/components/templates/tech_ofs_v1/index.vue')
        case 'boson_ru':
          return import('~/components/templates/boson_ru/index.vue')
      }
    }
    const templateName = ref(companyStore.templateName || companyStore.company?.companyTemplateSettings?.template?.name)
    const CompanyComponent = defineAsyncComponent(() => templateImport(templateName.value))

    if (process.client) {
      window.scrollTo(0, 0)
    }

    return {
      CompanyComponent
    }
  }
})
</script>

<style scoped>

</style>
